import type { UserManagerSettings } from 'oidc-client-ts'
import type { ISSOConfig } from '~/types/sso.config.types'
import { UserManager, WebStorageStateStore } from 'oidc-client-ts'
import webConfig from '~/config'

let userManager: UserManager | null = null

export function initOidcClient(ssoConfig: ISSOConfig): UserManager {
  if (userManager) {
    return userManager
  }

  const settings: UserManagerSettings = {
    authority: ssoConfig?.oAuthDomain,
    client_id: ssoConfig?.oAuthClientId,
    redirect_uri: webConfig.auth.redirect_uri,
    scope: ssoConfig.scopes,
    automaticSilentRenew: true,
    silent_redirect_uri: webConfig.auth.silent_redirect_uri,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  }

  if (ssoConfig.audience) {
    settings.extraQueryParams = {
      audience: ssoConfig.audience,
    }
  }

  userManager = new UserManager(settings)

  return userManager
}
